/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-escape */
import { Component } from 'react';
import { Button, Dropdown, Modal } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';

import '../../../activity.scss';

class DeleteLinkedActivity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      deleteLinkedActivitiesLoading: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modalOpen: !prevState.modalOpen,
    }));
  }

  async onDeleteLinkedActivity() {
    const { activity, deleteLinkedActivity } = this.props;
    await this.setState({ deleteLinkedActivitiesLoading: true });

    deleteLinkedActivity(activity.id);

    this.setState({ deleteLinkedActivitiesLoading: false, modalOpen: false });
  }

  render() {
    const { modalOpen, deleteLinkedActivitiesLoading } = this.state;
    const { t } = this.props;
    return (
      <Modal
        open={modalOpen}
        onOpen={() => this.toggle()}
        closeIcon={
          <div
            className="new-activity-modal-close-icon"
            onClick={() => this.toggle()}
          >
            &times;
          </div>
        }
        size="tiny"
        trigger={
          <Dropdown.Item className="activity-actions-dropdown-delete">
            <label className="activity-actions-text-warning">
              {t('activity.activity_plan.linked_activity.delete_activity')}
            </label>
          </Dropdown.Item>
        }
      >
        <Modal.Header>
          <div className="small-modal-header">
            {t('activity.activity_plan.linked_activity.delete_linked_activity')}
          </div>
        </Modal.Header>
        <Modal.Content>
          <p>
            {t(
              'activity.activity_plan.linked_activity.delete_linked_activity_confirmation'
            )}
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={() => this.toggle()}
            className="activity-activation-cancel-btn"
          >
            {t('actions.no')}
          </Button>
          <Button
            loading={deleteLinkedActivitiesLoading}
            disabled={deleteLinkedActivitiesLoading}
            onClick={() => this.onDeleteLinkedActivity()}
            className="new-collective-save-btn"
            content={t('actions.yes')}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

DeleteLinkedActivity = withTranslation()(DeleteLinkedActivity);
export { DeleteLinkedActivity };
